module.exports = __webpack_public_path__ + "img/7-one.bbf337d4.png";